import { Component, Inject, LOCALE_ID } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/pt/all';
import  '@angular/common/locales/pt'
import { MessageService } from '@progress/kendo-angular-l10n';
import { CustomMessagesService } from './services/custom-messages.service';

@Component({
  selector: 'app-root',
  styles: [' div { height: 100%;}'],
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';
  public customMsgService: CustomMessagesService;
constructor(public messages: MessageService, @Inject(LOCALE_ID) public localeId: string, public intlService: IntlService) {
  
    
    this.setLocale(this.localeId); 
    this.customMsgService = this.messages as CustomMessagesService;
    this.customMsgService.language =this.localeId;
  
  }

    public setLocale(locale: any): void {
      (this.intlService as CldrIntlService).localeId = locale;
  }


  }
